var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "6px",
    viewBox: "0 0 6 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dashboard",
    transform: "translate(-1295.000000, -443.000000)",
    fill: "#1B1B1B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hft-balance",
    transform: "translate(1110.000000, 331.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "slider",
    transform: "translate(0.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Diamond",
    points: "187.999894 8 185 5 187.999894 2 191 5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.7ac8520896d05c2aec6347b9409aa225.svg";
export { ForwardRef as ReactComponent };